import { BuyersCertificate } from '@api/types';
import { SmartLink, StyledTableRow, StyledTableRowSeparator, TableCell } from '@components';
import { useAppSelector, useAuth } from '@hooks';
import { getSpecialPage } from '@store/app/app.slice';
import { getTextFromHtml } from '@utils/text.utils';
import { buyersCertificateColumns, getCertificateItems } from './buyersCertificateList.config';

type BuyersCertificateListItemProps = {
  certificate: BuyersCertificate;
  isWorking?: boolean;
};

export const BuyersCertificateListRow = ({
  certificate,
  isWorking,
}: BuyersCertificateListItemProps) => {
  const { isBeremaUser } = useAuth();
  const certificateItems = getCertificateItems(certificate, isBeremaUser);

  const buyersCertificateDetailsBaseUrl = useAppSelector(
    getSpecialPage('buyersCertificateDetailsPage')
  ) as string;
  const buyersCertificateDetailsHref = `${buyersCertificateDetailsBaseUrl}?id=${certificate.id}`;

  return (
    <StyledTableRow iscursorpointer='true'>
      <SmartLink
        href={buyersCertificateDetailsHref}
        sx={{ display: 'contents', p: 8 }}
        className='link'
      >
        {certificateItems.map((item) => (
          <TableCell
            key={item.fieldName}
            isWorking={isWorking}
            searchWords={[]}
            filteredColumns={buyersCertificateColumns(isBeremaUser)}
            visibleColumnNames={buyersCertificateColumns(isBeremaUser).map((certificate) =>
              certificate.key.toLowerCase()
            )}
            fieldValue={getTextFromHtml(item.fieldValue || '')}
            fieldName={item.fieldName}
          />
        ))}
        <StyledTableRowSeparator />
      </SmartLink>
    </StyledTableRow>
  );
};
